var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ3SwitchOffForcing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.78 17.08a9.22 9.22 0 00-3.72 17.65v19.73L61 58.92l3.88-4.46-2.77-3.36 2.78-2.7-2.78-3.17 2.79-2.51v-7.65C67.5 33.1 70 30 70 26.3a9.22 9.22 0 00-9.22-9.22zm-.51 7.71a2.22 2.22 0 112.21-2.21 2.21 2.21 0 01-2.21 2.21zM26 26h4v24h-4V26zm1.75-9a21 21 0 100 42 21 21 0 000-42zm0 38a17 17 0 110-34 17 17 0 010 34z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J3_Switch_off_forcing.02ad0809.svg";
export { SvgJ3SwitchOffForcing as ReactComponent };